import { frontendURL } from 'dashboard/helper/URLHelper';
import FupFlowList from './FupFlowList.vue';
import FupFlowBuilder from './FupFlowBuilder.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/fup'),
    name: 'fup_flows',
    component: FupFlowList,
    meta: {
      permissions: ['administrator', 'flow_manage'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/fup/:flowId'),
    name: 'fup_flow_builder',
    component: FupFlowBuilder,
    meta: {
      permissions: ['administrator', 'flow_manage'],
    },
  },
];
